import { RouterProvider } from "react-router-dom";
import { reloadOnAppModeChange, usesMobileApp } from "@/lib/mobile-app";
import { MobileRouter } from "@mobile/router/mobile";
import { createWebRouter } from "./web";

// Web/PWA: swap routers when the viewport crosses the phone/desktop breakpoint
// (no-op on capacitor, which is always the Agent app).
reloadOnAppModeChange();

// Data router for the full desktop/web app, created once. Constant-folded away
// on the capacitor build (lean Agent app only), so createWebRouter + all desktop
// pages tree-shake out of dist-capacitor.
const webRouter = __TARGET__ === "capacitor" ? null : createWebRouter();

// Route-tree selection:
//   - capacitor build → always the lean mobile Agent router (BrowserRouter +
//     react-router-animated).
//   - web build → chosen at load by viewport: phone-sized gets the mobile
//     router, larger gets the full data router.
export function AppRouter() {
  if (__TARGET__ === "capacitor" || usesMobileApp() || !webRouter) {
    return <MobileRouter />;
  }
  return <RouterProvider router={webRouter} />;
}
